module.exports = new __parcel__URL__("57390_h.08da093c.jpg").toString();